import { ref } from "vue";

import { voiceAiService } from "@/services/voiceAiService";

/**
 * Voice AI API wrapper with loading/error state. No module-level caching —
 * the /api/voice-ai/config/ endpoint is a single row lookup and a cache here
 * would leak the previous user's config to the next user within the same
 * SPA load (logout/login without page refresh).
 */
export function useVoiceAI() {
  const loading = ref(false);
  const error = ref("");

  async function _withState(label, fn) {
    loading.value = true;
    error.value = "";
    try {
      return await fn();
    } catch (err) {
      error.value = err?.message || `Failed to ${label}`;
      throw err;
    } finally {
      loading.value = false;
    }
  }

  return {
    loading,
    error,
    getConfig: () => _withState("load Voice AI config", () => voiceAiService.getConfig()),
    listTemplates: () => _withState("load templates", () => voiceAiService.listTemplates()),
    listCalls: (filters = {}) => _withState("load call history", () => voiceAiService.listCalls(filters)),
    triggerCall: (payload) => _withState("trigger call", () => voiceAiService.triggerCall(payload)),
    cancelCall: (id) => _withState("cancel call", () => voiceAiService.cancelCall(id)),
  };
}
